import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

export const dropdownButton = css`
  flex-direction: row;
  justify-content: space-between;
`;

export const dropdownButtonCentered = css`
  justify-content: center;
`;

export const dropdownButtonContentWrapper = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const text = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: ${typography.weightBase};
`;

export const prefix = css`
  font-weight: ${typography.weightBold};
  margin-right: 0.25rem;
`;
